module.exports = __webpack_public_path__ + "static/media/mobile-app-promotion-it.447e86d4.png";